<template>
    <component :is="template">
        <v-layout fill-height class="member-login">
            <v-responsive height="100%">
                <div class="background-layout">
                    <v-img src="/images/ucardkorea/login-bg.png" max-width="100%" height="100%" />
                </div>
                <v-layout justify-center align-center fill-height class="px-4 py-8 py-md-16">
                    <v-responsive width="100%" height="auto" max-width="800">
                        <v-row justify="center">
                            <v-col cols="12" md="6">
                                <v-card elevation="0">
                                    <div class="pa-12px py-md-20px">
                                        <div class="text-center">
                                            <h3 class="tit tit--sm">아이디 찾기</h3>
                                        </div>
                                    </div>
                                    <v-divider/>
                                    <div class="pa-12px pa-md-20px">
                                        <v-row class="row--x-small">
                                            <v-col cols="12">
                                                <v-btn x-large block color="primary" @click="find('username')">본인인증</v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-card elevation="0">
                                    <div class="pa-12px py-md-20px">
                                        <div class="text-center">
                                            <h3 class="tit tit--sm">비밀번호 찾기</h3>
                                        </div>
                                    </div>
                                    <v-divider/>
                                    <div class="pa-12px pa-md-20px">
                                        <v-row class="row--x-small">
                                            <v-col cols="12">
                                                <v-text-field v-model="username" placeholder="아이디" outlined persistent-placeholder hide-details />
                                            </v-col>
                                            <v-col cols="12">
                                                <v-btn x-large block color="primary" @click="find('password')">본인인증</v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-responsive>
                </v-layout>
            </v-responsive>

            <kcp-cert ref="kcpCert" />
        </v-layout>
    </component>
</template>
<script>
import api from "@/api";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import KcpCert from "@/components/plugins/kcp/kcp-cert.vue";
import { mdiCertificateOutline } from "@mdi/js";
export default {
    components: {
        VPasswordField,
        KcpCert
    },
    data(){
        return {
            mdiCertificateOutline,

            username: null,
        };
    },
    mounted(){
        if(this.logon) this.$router.push(`/`);
    },
    methods: {
        find(type){
            switch(type){
                // 아이디 찾기 클릭했을때
                case "username": {
                    // 본인인증 콜백 등록
                    this.$refs.kcpCert.$off("input");
                    this.$refs.kcpCert.$on("input", async (payload) => {
                        let { username } = await api.v1.members.repair({ type: "username", _cert: payload._cert });
                        alert(`회원님의 아이디는 ${username} 입니다`);
                        this.username = username;
                    });

                    // 본인인증창 열기
                    this.$refs.kcpCert.open();
                    break;
                }
                // 비밀번호 찾기 클릭했을때
                case "password": {
                    if(this.validate()){
                        // 본인인증 콜백 등록
                        this.$refs.kcpCert.$off("input");
                        this.$refs.kcpCert.$on("input", async (payload) => {
                            await api.v1.members.repair({ type: "password", username: this.username, _cert: payload._cert });
                            alert("가입하신 연락처로 임시비밀번호가 발송되었습니다");
                        });
                        // 본인인증창 열기
                        this.$refs.kcpCert.open();
                    }
                    break;
                }
            }
        },
        validate(){
            try{
                if(!this.username) throw new Error("아이디를 입력해주세요");
                return true;
            }
            catch(error){
                alert(error.message);
                return false;
            }
        },
    },
    computed: {
        template(){
            return () => import(`@/templates/${this.$theme.pages.login}`);
        },
        logon(){
            return !!this.$store.state.accessToken;
        }
    },
}
</script>
<style scoped>
.member-login .title {
    font-size: 22px !important;
    font-weight: 600;
}
.member-login .background-layout {
    position: absolute; width: 100%; height: 100%; left: 0; right: 0; top: 0; bottom: 0;
}
</style>